"use strict";
/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.3.0.0 (NJsonSchema v10.1.11.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleEventAssignedStatusEnum = exports.RoleScope = exports.GrantType = exports.PayoutComparisonEnum = exports.ProductOrderStatusType = exports.WorkOrderSalesChannel = exports.TemplateEnum = exports.ComplianceReportOutputFormatEnum = exports.ComplianceReportEnum = exports.ExecutiveReportType = exports.PaymentMethod = exports.PayrollInvoiceStatus = exports.PayrollManualSortEnum = exports.ProductOrderAdjustmentType = exports.CompensationProfileEnum = exports.PayrollSortEnum = exports.SplittingModifierType = exports.OnboardingApplicationStatusType = exports.ReferenceValueType = exports.MessageTypeEnum = exports.CRSType = exports.GeoJSONObjectType = exports.JobStatus = exports.IcdCorporationStatusEnum = exports.FeatureFlagOption = exports.HostTypeEnum = exports.EmployeeStatusEnum = exports.ParameterAttributes = exports.SecurityRuleSet = exports.MemberTypes = exports.CallingConventions = exports.MethodAttributes = exports.MethodImplAttributes = exports.OvertimeType = exports.ModuleEnum = exports.MarkerIcon = exports.PayrollTypeEnum = void 0;
var PayrollTypeEnum;
(function (PayrollTypeEnum) {
    PayrollTypeEnum["AdvanceWage"] = "AdvanceWage";
    PayrollTypeEnum["CommissionAboveThreshold"] = "CommissionAboveThreshold";
    PayrollTypeEnum["CommissionExceedingGuaranteed"] = "CommissionExceedingGuaranteed";
    PayrollTypeEnum["PieceBased"] = "PieceBased";
    PayrollTypeEnum["RawInput"] = "RawInput";
})(PayrollTypeEnum = exports.PayrollTypeEnum || (exports.PayrollTypeEnum = {}));
var MarkerIcon;
(function (MarkerIcon) {
    MarkerIcon["DefaultPin"] = "DefaultPin";
    MarkerIcon["ColoredPin"] = "ColoredPin";
    MarkerIcon["TwoTonedCircle"] = "TwoTonedCircle";
})(MarkerIcon = exports.MarkerIcon || (exports.MarkerIcon = {}));
var ModuleEnum;
(function (ModuleEnum) {
    ModuleEnum["ApplicationAdministration"] = "ApplicationAdministration";
    ModuleEnum["TimeEntry"] = "TimeEntry";
    ModuleEnum["Roster"] = "Roster";
    ModuleEnum["Payroll"] = "Payroll";
    ModuleEnum["RsScheduling"] = "RsScheduling";
    ModuleEnum["ShowLocations"] = "ShowLocations";
    ModuleEnum["SalesTeams"] = "SalesTeams";
    ModuleEnum["Users"] = "Users";
    ModuleEnum["Commission"] = "Commission";
    ModuleEnum["Reports"] = "Reports";
    ModuleEnum["Auditing"] = "Auditing";
    ModuleEnum["Invoicing"] = "Invoicing";
    ModuleEnum["Financials"] = "Financials";
    ModuleEnum["Onboarding"] = "Onboarding";
    ModuleEnum["Leads"] = "Leads";
    ModuleEnum["ProgramAdministration"] = "ProgramAdministration";
    ModuleEnum["Payout"] = "Payout";
    ModuleEnum["RogersReports"] = "RogersReports";
    ModuleEnum["EventsCoordination"] = "EventsCoordination";
    ModuleEnum["EventsScheduling"] = "EventsScheduling";
})(ModuleEnum = exports.ModuleEnum || (exports.ModuleEnum = {}));
var OvertimeType;
(function (OvertimeType) {
    OvertimeType["NoPremiums"] = "NoPremiums";
    OvertimeType["ProportionalCommissionPremiums"] = "ProportionalCommissionPremiums";
    OvertimeType["WagePlusPaidCommissionPremiums"] = "WagePlusPaidCommissionPremiums";
    OvertimeType["CommissionRate"] = "CommissionRate";
    OvertimeType["WagePlusCommissionRate"] = "WagePlusCommissionRate";
    OvertimeType["RegularPlusCommissionRate"] = "RegularPlusCommissionRate";
    OvertimeType["OvertimePlusPaidCommissionRate"] = "OvertimePlusPaidCommissionRate";
})(OvertimeType = exports.OvertimeType || (exports.OvertimeType = {}));
var MethodImplAttributes;
(function (MethodImplAttributes) {
    MethodImplAttributes["IL"] = "Managed";
    MethodImplAttributes["Managed"] = "Managed";
    MethodImplAttributes["Native"] = "Native";
    MethodImplAttributes["OPTIL"] = "OPTIL";
    MethodImplAttributes["Runtime"] = "CodeTypeMask";
    MethodImplAttributes["CodeTypeMask"] = "CodeTypeMask";
    MethodImplAttributes["Unmanaged"] = "Unmanaged";
    MethodImplAttributes["ManagedMask"] = "Unmanaged";
    MethodImplAttributes["NoInlining"] = "NoInlining";
    MethodImplAttributes["ForwardRef"] = "ForwardRef";
    MethodImplAttributes["Synchronized"] = "Synchronized";
    MethodImplAttributes["NoOptimization"] = "NoOptimization";
    MethodImplAttributes["PreserveSig"] = "PreserveSig";
    MethodImplAttributes["AggressiveInlining"] = "AggressiveInlining";
    MethodImplAttributes["SecurityMitigations"] = "SecurityMitigations";
    MethodImplAttributes["InternalCall"] = "InternalCall";
    MethodImplAttributes["MaxMethodImplVal"] = "MaxMethodImplVal";
})(MethodImplAttributes = exports.MethodImplAttributes || (exports.MethodImplAttributes = {}));
var MethodAttributes;
(function (MethodAttributes) {
    MethodAttributes["ReuseSlot"] = "ReuseSlot";
    MethodAttributes["PrivateScope"] = "ReuseSlot";
    MethodAttributes["Private"] = "PrivateScope, Private";
    MethodAttributes["FamANDAssem"] = "PrivateScope, FamANDAssem";
    MethodAttributes["Assembly"] = "PrivateScope, Assembly";
    MethodAttributes["Family"] = "PrivateScope, Family";
    MethodAttributes["FamORAssem"] = "PrivateScope, FamORAssem";
    MethodAttributes["Public"] = "PrivateScope, Public";
    MethodAttributes["MemberAccessMask"] = "PrivateScope, MemberAccessMask";
    MethodAttributes["UnmanagedExport"] = "PrivateScope, UnmanagedExport";
    MethodAttributes["Static"] = "PrivateScope, Static";
    MethodAttributes["Final"] = "PrivateScope, Final";
    MethodAttributes["Virtual"] = "PrivateScope, Virtual";
    MethodAttributes["HideBySig"] = "PrivateScope, HideBySig";
    MethodAttributes["NewSlot"] = "PrivateScope, VtableLayoutMask";
    MethodAttributes["VtableLayoutMask"] = "PrivateScope, VtableLayoutMask";
    MethodAttributes["CheckAccessOnOverride"] = "PrivateScope, CheckAccessOnOverride";
    MethodAttributes["Abstract"] = "PrivateScope, Abstract";
    MethodAttributes["SpecialName"] = "PrivateScope, SpecialName";
    MethodAttributes["RTSpecialName"] = "PrivateScope, RTSpecialName";
    MethodAttributes["PinvokeImpl"] = "PrivateScope, PinvokeImpl";
    MethodAttributes["HasSecurity"] = "PrivateScope, HasSecurity";
    MethodAttributes["RequireSecObject"] = "PrivateScope, RequireSecObject";
    MethodAttributes["ReservedMask"] = "PrivateScope, ReservedMask";
})(MethodAttributes = exports.MethodAttributes || (exports.MethodAttributes = {}));
var CallingConventions;
(function (CallingConventions) {
    CallingConventions["Standard"] = "Standard";
    CallingConventions["VarArgs"] = "VarArgs";
    CallingConventions["Any"] = "Any";
    CallingConventions["HasThis"] = "HasThis";
    CallingConventions["ExplicitThis"] = "ExplicitThis";
})(CallingConventions = exports.CallingConventions || (exports.CallingConventions = {}));
var MemberTypes;
(function (MemberTypes) {
    MemberTypes["Constructor"] = "Constructor";
    MemberTypes["Event"] = "Event";
    MemberTypes["Field"] = "Field";
    MemberTypes["Method"] = "Method";
    MemberTypes["Property"] = "Property";
    MemberTypes["TypeInfo"] = "TypeInfo";
    MemberTypes["Custom"] = "Custom";
    MemberTypes["NestedType"] = "NestedType";
    MemberTypes["All"] = "All";
})(MemberTypes = exports.MemberTypes || (exports.MemberTypes = {}));
var SecurityRuleSet;
(function (SecurityRuleSet) {
    SecurityRuleSet["None"] = "None";
    SecurityRuleSet["Level1"] = "Level1";
    SecurityRuleSet["Level2"] = "Level2";
})(SecurityRuleSet = exports.SecurityRuleSet || (exports.SecurityRuleSet = {}));
var ParameterAttributes;
(function (ParameterAttributes) {
    ParameterAttributes["None"] = "None";
    ParameterAttributes["In"] = "In";
    ParameterAttributes["Out"] = "Out";
    ParameterAttributes["Lcid"] = "Lcid";
    ParameterAttributes["Retval"] = "Retval";
    ParameterAttributes["Optional"] = "Optional";
    ParameterAttributes["HasDefault"] = "HasDefault";
    ParameterAttributes["HasFieldMarshal"] = "HasFieldMarshal";
    ParameterAttributes["Reserved3"] = "Reserved3";
    ParameterAttributes["Reserved4"] = "Reserved4";
    ParameterAttributes["ReservedMask"] = "ReservedMask";
})(ParameterAttributes = exports.ParameterAttributes || (exports.ParameterAttributes = {}));
var EmployeeStatusEnum;
(function (EmployeeStatusEnum) {
    EmployeeStatusEnum["Active"] = "Active";
    EmployeeStatusEnum["Terminated"] = "Terminated";
    EmployeeStatusEnum["Pending"] = "Pending";
})(EmployeeStatusEnum = exports.EmployeeStatusEnum || (exports.EmployeeStatusEnum = {}));
var HostTypeEnum;
(function (HostTypeEnum) {
    HostTypeEnum["Retailer"] = "Retailer";
    HostTypeEnum["Corporation"] = "Corporation";
    HostTypeEnum["ShoppingMall"] = "ShoppingMall";
    HostTypeEnum["SpecialEvent"] = "SpecialEvent";
})(HostTypeEnum = exports.HostTypeEnum || (exports.HostTypeEnum = {}));
var FeatureFlagOption;
(function (FeatureFlagOption) {
    FeatureFlagOption["Optional"] = "optional";
    FeatureFlagOption["Enabled"] = "enabled";
    FeatureFlagOption["Disabled"] = "disabled";
    FeatureFlagOption["OptIn"] = "optIn";
    FeatureFlagOption["OptOut"] = "optOut";
    FeatureFlagOption["NoPreference"] = "noPref";
})(FeatureFlagOption = exports.FeatureFlagOption || (exports.FeatureFlagOption = {}));
var IcdCorporationStatusEnum;
(function (IcdCorporationStatusEnum) {
    IcdCorporationStatusEnum["Active"] = "Active";
    IcdCorporationStatusEnum["Inactive"] = "Inactive";
})(IcdCorporationStatusEnum = exports.IcdCorporationStatusEnum || (exports.IcdCorporationStatusEnum = {}));
var JobStatus;
(function (JobStatus) {
    JobStatus["Queued"] = "Queued";
    JobStatus["Processing"] = "Processing";
    JobStatus["Failed"] = "Failed";
    JobStatus["Succeeded"] = "Succeeded";
})(JobStatus = exports.JobStatus || (exports.JobStatus = {}));
var GeoJSONObjectType;
(function (GeoJSONObjectType) {
    GeoJSONObjectType["Point"] = "Point";
    GeoJSONObjectType["MultiPoint"] = "MultiPoint";
    GeoJSONObjectType["LineString"] = "LineString";
    GeoJSONObjectType["MultiLineString"] = "MultiLineString";
    GeoJSONObjectType["Polygon"] = "Polygon";
    GeoJSONObjectType["MultiPolygon"] = "MultiPolygon";
    GeoJSONObjectType["GeometryCollection"] = "GeometryCollection";
    GeoJSONObjectType["Feature"] = "Feature";
    GeoJSONObjectType["FeatureCollection"] = "FeatureCollection";
})(GeoJSONObjectType = exports.GeoJSONObjectType || (exports.GeoJSONObjectType = {}));
var CRSType;
(function (CRSType) {
    CRSType["Unspecified"] = "unspecified";
    CRSType["Name"] = "name";
    CRSType["Link"] = "link";
})(CRSType = exports.CRSType || (exports.CRSType = {}));
var MessageTypeEnum;
(function (MessageTypeEnum) {
    MessageTypeEnum["WelcomeMessageEmail"] = "WelcomeMessageEmail";
    MessageTypeEnum["PasswordReminderEmail"] = "PasswordReminderEmail";
    MessageTypeEnum["ProfileUpdateEmail"] = "ProfileUpdateEmail";
    MessageTypeEnum["HerbJoyBulletin"] = "HerbJoyBulletin";
    MessageTypeEnum["UserFeedback"] = "UserFeedback";
    MessageTypeEnum["ApprovedOnboardingApplication"] = "ApprovedOnboardingApplication";
    MessageTypeEnum["PayrollProcessorAlert"] = "PayrollProcessorAlert";
    MessageTypeEnum["FailedTimeEntriesSyncAlert"] = "FailedTimeEntriesSyncAlert";
    MessageTypeEnum["CreatedOnboardingApplication"] = "CreatedOnboardingApplication";
    MessageTypeEnum["TerminatedOnboardingApplication"] = "TerminatedOnboardingApplication";
    MessageTypeEnum["WorkOrderUpdateAlert"] = "WorkOrderUpdateAlert";
    MessageTypeEnum["PasswordExpiryNotificationAlert"] = "PasswordExpiryNotificationAlert";
    MessageTypeEnum["EmployeeTerminationAlert"] = "EmployeeTerminationAlert";
})(MessageTypeEnum = exports.MessageTypeEnum || (exports.MessageTypeEnum = {}));
var ReferenceValueType;
(function (ReferenceValueType) {
    ReferenceValueType["String"] = "String";
    ReferenceValueType["Boolean"] = "Boolean";
})(ReferenceValueType = exports.ReferenceValueType || (exports.ReferenceValueType = {}));
var OnboardingApplicationStatusType;
(function (OnboardingApplicationStatusType) {
    OnboardingApplicationStatusType["Initial"] = "Initial";
    OnboardingApplicationStatusType["Hidden"] = "Hidden";
    OnboardingApplicationStatusType["Approved"] = "Approved";
    OnboardingApplicationStatusType["Terminated"] = "Terminated";
    OnboardingApplicationStatusType["Incomplete"] = "Incomplete";
    OnboardingApplicationStatusType["Suspended"] = "Suspended";
    OnboardingApplicationStatusType["SelfSignUp"] = "SelfSignUp";
})(OnboardingApplicationStatusType = exports.OnboardingApplicationStatusType || (exports.OnboardingApplicationStatusType = {}));
var SplittingModifierType;
(function (SplittingModifierType) {
    SplittingModifierType["Number"] = "Number";
    SplittingModifierType["Percent"] = "Percent";
})(SplittingModifierType = exports.SplittingModifierType || (exports.SplittingModifierType = {}));
var PayrollSortEnum;
(function (PayrollSortEnum) {
    PayrollSortEnum["Owner"] = "Owner";
    PayrollSortEnum["ClientName"] = "ClientName";
    PayrollSortEnum["Division"] = "Division";
    PayrollSortEnum["StartDate"] = "StartDate";
    PayrollSortEnum["StartDateDesc"] = "StartDateDesc";
    PayrollSortEnum["EndDate"] = "EndDate";
    PayrollSortEnum["EndDateDesc"] = "EndDateDesc";
    PayrollSortEnum["LockedDate"] = "LockedDate";
    PayrollSortEnum["LockedDateDesc"] = "LockedDateDesc";
    PayrollSortEnum["CompletedDate"] = "CompletedDate";
    PayrollSortEnum["CompletedDateDesc"] = "CompletedDateDesc";
})(PayrollSortEnum = exports.PayrollSortEnum || (exports.PayrollSortEnum = {}));
var CompensationProfileEnum;
(function (CompensationProfileEnum) {
    CompensationProfileEnum["Dept100"] = "Dept100";
    CompensationProfileEnum["Dept200"] = "Dept200";
    CompensationProfileEnum["Dept400"] = "Dept400";
    CompensationProfileEnum["Dept750"] = "Dept750";
    CompensationProfileEnum["Dept900"] = "Dept900";
})(CompensationProfileEnum = exports.CompensationProfileEnum || (exports.CompensationProfileEnum = {}));
var ProductOrderAdjustmentType;
(function (ProductOrderAdjustmentType) {
    ProductOrderAdjustmentType["InnovageRogersAmount"] = "InnovageRogersAmount";
})(ProductOrderAdjustmentType = exports.ProductOrderAdjustmentType || (exports.ProductOrderAdjustmentType = {}));
var PayrollManualSortEnum;
(function (PayrollManualSortEnum) {
    PayrollManualSortEnum["CompletedDate"] = "CompletedDate";
    PayrollManualSortEnum["CompletedDateDesc"] = "CompletedDateDesc";
    PayrollManualSortEnum["SubmittedDate"] = "SubmittedDate";
    PayrollManualSortEnum["SubmittedDateDesc"] = "SubmittedDateDesc";
})(PayrollManualSortEnum = exports.PayrollManualSortEnum || (exports.PayrollManualSortEnum = {}));
var PayrollInvoiceStatus;
(function (PayrollInvoiceStatus) {
    PayrollInvoiceStatus["NotPosted"] = "NotPosted";
    PayrollInvoiceStatus["Posted"] = "Posted";
})(PayrollInvoiceStatus = exports.PayrollInvoiceStatus || (exports.PayrollInvoiceStatus = {}));
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["DrawFromLocalBankAccount"] = "DrawFromLocalBankAccount";
    PaymentMethod["OutOfSecurity"] = "OutOfSecurity";
})(PaymentMethod = exports.PaymentMethod || (exports.PaymentMethod = {}));
var ExecutiveReportType;
(function (ExecutiveReportType) {
    ExecutiveReportType["Compliance"] = "Compliance";
})(ExecutiveReportType = exports.ExecutiveReportType || (exports.ExecutiveReportType = {}));
var ComplianceReportEnum;
(function (ComplianceReportEnum) {
    ComplianceReportEnum["HourlyRate"] = "HourlyRate";
    ComplianceReportEnum["HourlyRateActive"] = "HourlyRateActive";
    ComplianceReportEnum["CellAllowance"] = "CellAllowance";
    ComplianceReportEnum["Tip"] = "Tip";
    ComplianceReportEnum["CellAllowance2"] = "CellAllowance2";
    ComplianceReportEnum["TravelAllowance"] = "TravelAllowance";
    ComplianceReportEnum["SplitPay"] = "SplitPay";
    ComplianceReportEnum["NoMealBreak"] = "NoMealBreak";
    ComplianceReportEnum["MealBreakBelow30Min"] = "MealBreakBelow30Min";
    ComplianceReportEnum["SecondMealBreak"] = "SecondMealBreak";
    ComplianceReportEnum["RecordedTimeSecondShiftBelow2Hour"] = "RecordedTimeSecondShiftBelow2Hour";
    ComplianceReportEnum["MealBreakTooEarlyOrLate"] = "MealBreakTooEarlyOrLate";
    ComplianceReportEnum["SeventhDayOfRest"] = "SeventhDayOfRest";
    ComplianceReportEnum["Bonus"] = "Bonus";
    ComplianceReportEnum["RecordedTimeLapseBelow5Min"] = "RecordedTimeLapseBelow5Min";
    ComplianceReportEnum["RecordedTimeLapse5to60Min"] = "RecordedTimeLapse5to60Min";
    ComplianceReportEnum["RecordedTimeLapseAbove60Min"] = "RecordedTimeLapseAbove60Min";
    ComplianceReportEnum["TotalHoursOver60"] = "TotalHoursOver60";
    ComplianceReportEnum["TotalHoursOver70"] = "TotalHoursOver70";
    ComplianceReportEnum["Worked7WorkDaysInRow"] = "Worked7WorkDaysInRow";
    ComplianceReportEnum["NoWorkHoursWithMealBreak"] = "NoWorkHoursWithMealBreak";
    ComplianceReportEnum["OverlappingTimeEntries"] = "OverlappingTimeEntries";
    ComplianceReportEnum["NetPayAddition"] = "NetPayAddition";
    ComplianceReportEnum["NetPayDeduction"] = "NetPayDeduction";
    ComplianceReportEnum["IncompleteTimeEntries"] = "IncompleteTimeEntries";
    ComplianceReportEnum["FirstMealBreakReport"] = "FirstMealBreakReport";
    ComplianceReportEnum["AllTimeRecordsReport"] = "AllTimeRecordsReport";
    ComplianceReportEnum["RSCostcoReport"] = "RSCostcoReport";
    ComplianceReportEnum["AdditionalHoursReport"] = "AdditionalHoursReport";
})(ComplianceReportEnum = exports.ComplianceReportEnum || (exports.ComplianceReportEnum = {}));
var ComplianceReportOutputFormatEnum;
(function (ComplianceReportOutputFormatEnum) {
    ComplianceReportOutputFormatEnum["MultipleWorksheets"] = "MultipleWorksheets";
    ComplianceReportOutputFormatEnum["SingleMergedWorksheet"] = "SingleMergedWorksheet";
})(ComplianceReportOutputFormatEnum = exports.ComplianceReportOutputFormatEnum || (exports.ComplianceReportOutputFormatEnum = {}));
var TemplateEnum;
(function (TemplateEnum) {
    TemplateEnum["Payroll"] = "Payroll";
    TemplateEnum["TimeEntry"] = "TimeEntry";
    TemplateEnum["Schedule"] = "Schedule";
})(TemplateEnum = exports.TemplateEnum || (exports.TemplateEnum = {}));
var WorkOrderSalesChannel;
(function (WorkOrderSalesChannel) {
    WorkOrderSalesChannel["Unknown"] = "Unknown";
    WorkOrderSalesChannel["DoorToDoor"] = "DoorToDoor";
    WorkOrderSalesChannel["Event"] = "Event";
})(WorkOrderSalesChannel = exports.WorkOrderSalesChannel || (exports.WorkOrderSalesChannel = {}));
var ProductOrderStatusType;
(function (ProductOrderStatusType) {
    ProductOrderStatusType["Booked"] = "Booked";
    ProductOrderStatusType["Installed"] = "Installed";
    ProductOrderStatusType["Cancelled"] = "Cancelled";
    ProductOrderStatusType["Disconnect"] = "Disconnect";
})(ProductOrderStatusType = exports.ProductOrderStatusType || (exports.ProductOrderStatusType = {}));
var PayoutComparisonEnum;
(function (PayoutComparisonEnum) {
    PayoutComparisonEnum["PositivePayoutComparison"] = "PositivePayoutComparison";
    PayoutComparisonEnum["NegativePayoutComparison"] = "NegativePayoutComparison";
    PayoutComparisonEnum["NeutralPayoutComparison"] = "NeutralPayoutComparison";
})(PayoutComparisonEnum = exports.PayoutComparisonEnum || (exports.PayoutComparisonEnum = {}));
var GrantType;
(function (GrantType) {
    GrantType["GrantAll"] = "GrantAll";
    GrantType["GrantRole"] = "GrantRole";
    GrantType["GrantClaims"] = "GrantClaims";
    GrantType["None"] = "None";
})(GrantType = exports.GrantType || (exports.GrantType = {}));
var RoleScope;
(function (RoleScope) {
    RoleScope["Global"] = "Global";
    RoleScope["Divisional"] = "Divisional";
    RoleScope["Organizational"] = "Organizational";
    RoleScope["EmploymentRecord"] = "EmploymentRecord";
    RoleScope["Hidden"] = "Hidden";
})(RoleScope = exports.RoleScope || (exports.RoleScope = {}));
var ScheduleEventAssignedStatusEnum;
(function (ScheduleEventAssignedStatusEnum) {
    ScheduleEventAssignedStatusEnum["Pending"] = "Pending";
    ScheduleEventAssignedStatusEnum["Accepted"] = "Accepted";
    ScheduleEventAssignedStatusEnum["Rejected"] = "Rejected";
    ScheduleEventAssignedStatusEnum["Unassigned"] = "Unassigned";
})(ScheduleEventAssignedStatusEnum = exports.ScheduleEventAssignedStatusEnum || (exports.ScheduleEventAssignedStatusEnum = {}));
//# sourceMappingURL=models.js.map